/* eslint-disable react/prop-types */
import React from 'react';
import Careers from './Careers';

export default () => ({
  chunks: ['careers'],

  component: <Careers />,
  accountWrapper: {
    loginRequired: false,
  },
});

if (module.hot) {
  module.hot.accept();
}
